import { useLocation, useSearchParams } from 'react-router-dom'

import { AppAdviceText } from 'shared/ui/app-advice-text'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { GalleryImages } from 'shared/ui/image-carousel/styles.ts'
import { ImageGallery } from 'shared/ui/image-gallery'
import { Loader } from 'shared/ui/loader'

import { DefaultSlideIndex, RadixBase } from './model.ts'
import s from './styles.module.scss'

const UmrahPreviewPage = () => {
  const [params] = useSearchParams()
  const previewIndex = params.get('index')
  const { title, images } = useLocation().state as {
    title: string
    images: GalleryImages[]
  }

  if (!title || !images) {
    return (
      <div className="container">
        <Loader marginTop={200} />
        <AppAdviceText />
      </div>
    )
  }

  return (
    <div>
      <HeaderGoBack
        variant={'grey'}
        buttonWhite
        title={title}
      />
      <div className={s.content}>
        <ImageGallery
          isFullHeight
          initialSlideIndex={
            previewIndex ? parseInt(previewIndex, RadixBase) : DefaultSlideIndex
          }
          images={images.map((i) => i.image)}
        />
      </div>
    </div>
  )
}

export default UmrahPreviewPage
